import { NgClass } from "@angular/common";
import { AfterViewInit, Component, ElementRef, Inject, OnInit, Renderer2, signal } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import {
  buildPushToastPayload,
  readLanguageCodeFromStorage,
  resolvePushToastLanguage,
} from "@core/push-notification-toast.i18n";
import { UtilityService } from "@core/utility.service";
import { IonicModule, MenuController, ModalController } from "@ionic/angular";
import * as _ from "lodash";
import { map, Observable, Subscription } from "rxjs";
import { CommonVariable } from "src/app/app.constants";
import { ReferFriendComponent } from "src/app/components/refer-friend/refer-friend.component";
import { StoreRepositoryService } from "src/app/pages/store/store-repository.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { MarketingCampaignsService } from "src/app/services/marketing-campaigns.service";
import { OneSignalService } from "src/app/services/one-signal.service";
import { RequestProfileService } from "src/app/services/RequestBodyService/RequestProfile/request-profile.service";
@Component({
  selector: "app-inbox-template",
  templateUrl: "./inbox-template.component.html",
  styleUrls: ["./inbox-template.component.scss"],
  standalone: true,
  imports: [IonicModule, NgClass],
})
export class InboxTemplateComponent implements OnInit, AfterViewInit {
  messageData: Data;
  bodyData: Data;
  countDownData: Data;
  buttonData: Data;
  heroData: Data;
  backgroundStyle: Data;
  heroImageStyle: Data;
  countDownStyle: Data;
  bodyStyle: Data;
  buttonStyle: Data;
  defaultBodyStyle: Data;
  defaultBackgroundStyle: Data;
  countDownText: Data[];
  heroText: Data[];
  bodyText: Data[];
  inboxposition: Data;
  hideCloseButton: boolean;
  public userId: string;
  urlToPartnerOfferPage = "/partner-offer";
  linkDestinations = {
    pushRequest: "pushrequest",
    referFriend: "/refer_friend",
  }

  regex = /\/games\/(skill-game|instant-win-game|game-blog|replayable|adventure-game|rapid-fire-game)(\/.*)?/;
  private preferredCurrency = "GBP";
  private preferredCurrencySignal = signal<string>("GBP")

  private currencySymbol = "£";
  private currencySymbolSignal = signal<string>("£")

  private userDetailsSubscription: Subscription;
  private getCurrencyListSubscription: Subscription;
  private jackpotSubscription: Subscription;
  private jackpotsData: Data[];
  private sumJackpotKey = "[sum_jackpot=";
  private jackpotValueKey = "[jackpot_value=";
  private jackpotNextDrawDateKey = "[count_nearest_draw_date=";
  private jackpotEndPromotionKey = "[count_end_of_promotion=";
  private jackpotCountDownKey = "[countdown:";
  private endOfPromotionPattern = /\[count_end_of_promotion=([^[\]]+)]/;
  private confettis = true;
  messageDataStringify: string;
  constructor(
    private firestore: Firestore,
    private GTMSegment: GTMSegmentService,
    private router: Router,
    private matBottomSheet: MatBottomSheetRef<InboxTemplateComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public inboxData: Data,
    private authService: AuthService,
    private oneSignalService: OneSignalService,
    private storeService: StoreRepositoryService,
    private menu: MenuController,
    private modalController: ModalController,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private el: ElementRef,
    private RequestProfileService: RequestProfileService,
    private marketingCampaignsService: MarketingCampaignsService,
  ) {
    this.messageData = _.cloneDeep(this.inboxData);
    this.messageDataStringify = JSON.stringify(this.messageData);
    if (
      this.messageDataStringify?.includes(this.jackpotValueKey) ||
      this.messageDataStringify?.includes(this.jackpotNextDrawDateKey) ||
      this.messageDataStringify?.includes(this.sumJackpotKey)
    ) {
      this.userDetailsSubscription = this.authService?.userDetails$?.subscribe(
        (user: Data) => {
          this.preferredCurrencySignal.set(user?.preferred_currency ?? CommonVariable.preferredCurrency);
          this.preferredCurrency = this.preferredCurrencySignal(); this.getCurrencyListSubscription = this.authService?.getCurrencyList$?.subscribe((data: Data) => {
            const CurrencyDetails = data?.details?.find((x: Data) => x?.currency_code === this.preferredCurrencySignal());
            this.currencySymbolSignal.set(CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol)
            this.currencySymbol = this.currencySymbolSignal()
            this.fetchJackpotData();
          });
        },
        (err) => {
          return err;
        }
      );
    } else if (this.messageDataStringify?.includes(this.jackpotEndPromotionKey)
    ) {
      this.countEndOfPromotion();
    }
    this.messageData = JSON.parse(this.messageDataStringify);
    const limbId = this.messageData?.limb_id === this.messageData?.id ? this.messageData?.limb_id : this.messageData?.id;
    const path_id = "dQ2JLcXGOr5fbVp8gyIf";
    const doc_data = { auto_show: false, viewed: true, view_count: this.messageData?.view_count + 1 };
    const dv = { docId: limbId };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        console.error("Error updating Firestore document:", error);
        return error;
      }
    });
    const { background, hero, countdown, body, button } = this.messageData ?? {};
    this.heroData = hero ?? false;
    this.countDownData = countdown?.visible ?? false;
    this.bodyData = body ?? false;
    this.buttonData = button ?? false;
    // Background
    const defaultBackGround = {
      "width": "100%",
      "padding": "15px",
      "height": `${background?.height_pct}%` || "80vh",
      "overflowY": "auto",
    }
    const backgroundImage = {
      ...defaultBackGround,
      "background": `url('${background?.image_url}')`,
      "backgroundSize": "cover",
      "backgroundPosition": "top",
    }
    this.backgroundStyle = background?.image_url ? backgroundImage
      : {
        ...defaultBackGround,
        "backgroundColor": "#fff",
      }
    if (background?.position === "bottom") {
      this.inboxposition = { "align-items": "flex-end" };
    } else if (background?.position === "top") {
      this.inboxposition = { "align-items": "flex-top" };
    } else if (background?.position === "center") {
      this.inboxposition = { "align-items": "center" };
    }
    // Hide inbox message if top position
    this.hideCloseButton = background?.position === "top";
    // Hero
    const { image_height_pct, image_padding_left_pct, image_padding_right_pct, image_padding_top_pct, image_url, text } = hero ?? {};
    this.heroText = text;
    this.heroImageStyle = {
      "border-radius": "8px",
      "height": `${image_height_pct}%` || "40vh",
      "display": "flex",
      "alignItems": "flex-start",
      "backgroundImage": `url(${image_url})`,
      "backgroundPosition": "center",
      "backgroundSize": "cover",
      "width": "80%",
      "padding-left": `${image_padding_left_pct}%` || "10%",
      "padding-right": `${image_padding_right_pct}%` || "10%",
      "padding-top": `${image_padding_top_pct}%` || "10%",
    };
    // Countdown 
    this.countDownStyle = {
      ...countdown?.countdown_custom_style,
    }
    this.countDownText = countdown?.text;
    if (this.messageDataStringify?.includes(this.jackpotCountDownKey)) {
      this.countExpiryData(this.countDownText);
    }
    // Body
    this.bodyStyle = {
      ...body?.body_custom_style,
    }
    this.defaultBackgroundStyle = this.backgroundStyle;
    this.defaultBodyStyle = this.bodyStyle;
    this.bodyText = body?.text;
    // Button
    const invertedColor = button?.inverted_color ?? "#7564e3";
    const invertedBGColor = button?.inverted_bg_color ?? "#fff";
    const defaultButton = {
      "font-weight": button?.style ?? "normal",
      "height": `${button?.height_px}px` || "56px",
      "width": `${button?.width_px}px` || "265px",
    }
    const floatableButton = {
      ...defaultButton,
      "position": "fixed",
      "top": `${button?.position_pct}%` || "20px",
      "left": "0",
      "right": "0"
    }
    this.buttonStyle = button?.floatable ? floatableButton : defaultButton;
    if (button?.style === "inverted") {
      this.buttonStyle = {
        ...this.buttonStyle,
        "color": invertedColor,
        "background-color": invertedBGColor,
      }
    }
    this.buttonStyle = {
      ...this.buttonStyle,
      ...button?.button_custom_style,
    }
  }

  ngAfterViewInit(): void {
    if (this.messageData?.body?.body_custom_template || this.messageData?.countdown?.countdown_custom_template) {
      // Combine custom templates if they exist
      const cssChanges = [
        this.messageData?.body?.body_custom_template,
        this.messageData?.countdown?.countdown_custom_template,
      ]
        .filter(Boolean)
        .join("");

      // Proceed if there's any CSS to inject
      if (cssChanges) {
        const styleElement = this.renderer.createElement("style");
        styleElement.type = "text/css";
        styleElement.textContent = cssChanges;

        // Insert the style element before the first child of the current element
        this.renderer.insertBefore(this.el.nativeElement, styleElement, this.el.nativeElement.firstChild);
      }
    }
  }

  async ngOnInit() {
    await this.authService.getUid("InboxTemplateComponent").then((uid) => {
      this.userId = uid;
    })
    const mediaQuery = window.matchMedia("(min-width: 600px)");
    this.checkAndApplyStyles(mediaQuery.matches);
    mediaQuery.addEventListener("change", () => {
      this.checkAndApplyStyles(mediaQuery.matches);
    });
  }

  checkAndApplyStyles(mediaQueryFlag: boolean): void {
    if (mediaQueryFlag) {
      this.applyDesktopMediaQueryStyles();
    } else {
      this.applyMobileMediaQueryStyles();
    }
  }

  applyDesktopMediaQueryStyles(): void {
    this.backgroundStyle = {
      ...this.backgroundStyle, // Keep existing styles
      ...this.messageData?.background?.desktop,
    };
    this.bodyStyle = {
      ...this.bodyStyle,
      ...this.messageData?.body?.desktop,
    };
  }

  applyMobileMediaQueryStyles(): void {
    this.backgroundStyle = this.defaultBackgroundStyle;
    this.bodyStyle = this.defaultBodyStyle;
  }

  checkIfCustomStyleExists(): boolean {
    const styleFlag = !(this.countDownStyle && Object?.keys(this.countDownStyle)?.length);
    return styleFlag;
  }

  fetchJackpotData() {
    this.jackpotSubscription = this.storeService.storePageData$.subscribe((data) => {
      if (!data) return;
      this.jackpotsData = data;
      this.checkForJackpotProduct();
      this.checkForJackpotDrawDate();
      this.checkForSumJackpot();
    });
  }

  checkForSumJackpot() {
    const regex = /\[sum_jackpot=([^[\]]*)]/;
    const match = this.messageDataStringify.match(regex);
    if (match) {
      const productNames = match[1]?.split(",");
      const sumJackpot = this.calculateSumJackpot(productNames);
      const formattedSum = this.convertJackpotNumberToString(sumJackpot);
      this.messageDataStringify = this.messageDataStringify.replace(
        match[0],
        this.currencySymbolSignal() + formattedSum
      );
    }
  }

  calculateSumJackpot(productNames: string[]): number {
    let sum = 0;
    for (const productName of productNames) {
      const product = this.jackpotsData.find((p) => p?.real_name?.toLowerCase() === productName.toLowerCase());
      if (product && product?.jackpot?.jackpot_value) {
        const productIntValue = this.getIntJackpotData(product);
        const jackpotValue = this.convertJackpotStringToNumber(productIntValue);
        sum += jackpotValue ?? 0;
      }
    }
    return sum;
  }

  convertJackpotNumberToString(jackpotNumber: number): string {
    if (jackpotNumber >= 1000000000) {
      return (jackpotNumber / 1000000000)?.toFixed(0) + "B";
    } else if (jackpotNumber >= 1000000) {
      return (jackpotNumber / 1000000)?.toFixed(0) + "M";
    } else if (jackpotNumber >= 1000) {
      return (jackpotNumber / 1000)?.toFixed(0) + "K";
    } else {
      return jackpotNumber?.toFixed(0);
    }
  }

  convertJackpotStringToNumber(jackpotString: string): number {
    const value = parseFloat(jackpotString);
    if (jackpotString?.toLowerCase()?.endsWith("k")) {
      return value * 1000;
    } else if (jackpotString?.toLowerCase()?.endsWith("m")) {
      return value * 1000000;
    } else {
      return value;
    }
  }

  private checkForJackpotProduct() {
    const regex = /\[jackpot_value=([^[\]]*)]/;
    const match = this.messageDataStringify.match(regex);
    if (match) {
      let product: Data;
      if (match[1] === "rapidfire") {
        product = this.storeService.RapidFire;
      } else {
        product = this.jackpotsData.find((p) => p?.real_name?.toLowerCase() === match[1].toLowerCase());
      }
      if (product && product?.jackpot?.jackpot_value) {
        const jackpotRegex = /\[jackpot_value=[^\]]*]/;
        const productIntValue = this.getIntJackpotData(product);
        this.messageDataStringify = this.messageDataStringify.replace(
          jackpotRegex,
          this.currencySymbolSignal() + productIntValue
        );
      }
    }
  }

  private checkForJackpotDrawDate() {
    const regex = /\[count_nearest_draw_date=([^[\]]*)]/;
    const match = this.messageDataStringify.match(regex);
    if (match) {
      let product: Data;
      if (match[1] === "rapidfire") {
        product = this.storeService.RapidFire;
      } else {
        product = this.jackpotsData.find((p) => p?.real_name?.toLowerCase() === match[1].toLowerCase());
      }
      if (product) {
        const drawDateRegex = /\[count_nearest_draw_date=[^\]]*]/;

        const expiryDate = product?.jackpot?.expiry_date.seconds * 1000;
        const now = new Date().getTime();
        const timeDifference = expiryDate - now;

        let nextDrawString = "";

        if (timeDifference <= 0) {
          nextDrawString = "expired";
        } else {
          nextDrawString = this.formatTime(timeDifference);
          this.messageDataStringify = this.messageDataStringify.replace(drawDateRegex, nextDrawString);
        }
      }
    }
  }



  getIntJackpotData(product) {
    return product?.jackpot?.int_jackpot_value?.[this.preferredCurrencySignal()]
      ? product?.jackpot?.int_jackpot_value?.[this.preferredCurrencySignal()]
      : product?.jackpot?.jackpot_value;
  }
  closeDialog() {
    this.matBottomSheet.dismiss();
  }

  // This method is used to open the url based on the destination provided in the inbox message
  openUrl() {
    this.matBottomSheet.dismiss();
    this.checkForFreePlay();
    const link = this.messageData?.destination;
    if (link === this.linkDestinations.pushRequest) {
      this.activateNotification();
    } else if (link === this.linkDestinations.referFriend) {
      this.referFriend();
      return;
    } else {
      const match = link.match(this.regex);
      if (match) {
        const pathToGamesDetails = match[0];
        this.router.navigateByUrl(pathToGamesDetails);
      } else if (link && link.search("typeform") > -1) {
        this.marketingCampaignsService.triggerTypeForm(link);
      } else if (link && link?.search(this.urlToPartnerOfferPage) > -1) {
        const path = link?.split("/");
        if (path && path?.length > 0) {
          this.router.navigateByUrl(path[path.length - 1]);
        }
      } else if (link && link.search("offer") > -1) {
        const productName = link?.split("?")[1];
        this.router.navigateByUrl("/store/products/" + productName?.split("&")[0].trim());
      } else {
        this.router.navigateByUrl(link);
      }
    }
  }

  // this method is used to open the refer friend modal
  public async referFriend() {
    await this.menu.close().catch((err) => {
      throw err;
    });

    const modal = await this.modalController.create({
      component: ReferFriendComponent,
      componentProps: {
        confettis: this.confettis,
      },
      cssClass: "modal-fullScreen",
    });

    return await modal.present();
  }

  public activateNotification() {
    try {
      if (!UtilityService.isAppInstalledOnHomePage() && CommonVariable.device.operatingSystem === "ios") {
        const lang = this.resolvePushToastLang();
        const installToast = buildPushToastPayload("install_app_to_activate", lang, {
          duration: 2000,
          icon: "tick circle error.svg",
          type: "Error",
        });
        const fallbackToast = buildPushToastPayload("something_went_wrong", lang, {
          icon: "tick circle error.svg",
          type: "Error",
        });
        this.authService?.showToastMessage(installToast, fallbackToast);
        return;
      }
      if (this.userId) {
        // calling push notification service
        this.oneSignalService.optIn(this.userId).subscribe({
          error: (error) => {
            console.error("Error while activating push notification from inbox template", error);
          },
        });
      } else {
        const defaultMsg = buildPushToastPayload(
          "something_went_wrong",
          this.resolvePushToastLang(),
          {
            duration: 2000,
            icon: "tick circle error.svg",
            type: "Error",
          }
        );
        this.authService?.showToastMessage(null, defaultMsg);
        throw new Error("userID is null or undefined");
      }
    } catch (err) {
      return err;
    }
  }

  private resolvePushToastLang(): string {
    return resolvePushToastLanguage(
      this.authService?.selectedlanguage$?.value,
      readLanguageCodeFromStorage()
    );
  }
  checkForFreePlay() {
    try {
      if (this.messageData?.issue?.assign_free_play) {
        this.authService
          ?.getV2CloudFunction(
            "apisyncv2",
            this.RequestProfileService?.inboxMessageHideRequest(
              this.messageData,
              this.messageData?.issue?.reason
            )
          )
          .subscribe(
            (res) => {
              if (res?.status?.includes("success")) {
                this.hideInboxMessage();
              }
            },
            (err) => err
          );
      }
    } catch (error) {
      return error;
    }
  }


  hideInboxMessage() {
    const limbId = this.messageData?.limb_id === this.messageData?.id ? this.messageData?.limb_id : this.messageData?.id;
    this.GTMSegment?.GTMPopupInitialization("InboxDelete");

    const path_id = "dQ2JLcXGOr5fbVp8gyIf";
    const doc_data = { hide: true };
    const method = "update";
    const dv = { docId: limbId };

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method
    }).subscribe({
      error: (error) => {
        console.error("Error updating inbox message:", error);
        return error;
      }
    });
  }

  private countExpiryData(textArray: Data[]): void {
    if (!textArray) return;
    this.countDownText = textArray.map((eachObj) => {
      const content = eachObj.content;
      const countDv = "[countdown:expiry_date]";
      const match = content.includes(countDv);
      let expiryDate =
        this.messageData?.countdown_expriy_date?.seconds || this.messageData?.countdown_expriy_date?._seconds;
      if (match && expiryDate) {
        expiryDate = expiryDate * 1000;
        const now = new Date().getTime();
        const timeDifference = expiryDate - now;
        let nextDrawString = "";
        if (timeDifference <= 0) {
          nextDrawString = "expired";
        } else {
          nextDrawString = this.formatTime(timeDifference);
        }
        eachObj.content = this.sanitizeHTML(content.replace(countDv, nextDrawString));
        return eachObj;
      } else {
        return eachObj;
      }
    });
  }

  sanitizeHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private countEndOfPromotion(): void {
    const endOfPromotionMatch = this.messageDataStringify.match(this.endOfPromotionPattern);
    if (endOfPromotionMatch && endOfPromotionMatch.length > 1) {
      const matchedTemplate = endOfPromotionMatch[1];
      this.getGlobalTemplateData(matchedTemplate).subscribe(
        (res: Data) => {
          if (res) {
            const regex = /\[count_end_of_promotion=([^[\]]*)]/;
            const match = this.messageDataStringify.match(regex);

            if (match) {
              const drawDateRegex = /\[count_end_of_promotion=[^\]]*]/;

              const expiryDate = res?.expiry_date.seconds * 1000;
              const now = new Date().getTime();
              const timeDifference = expiryDate - now;

              let nextDrawString = "";

              if (timeDifference <= 0) {
                nextDrawString = "expired";
              } else {
                nextDrawString = this.formatTime(timeDifference);
                this.messageDataStringify = this.messageDataStringify.replace(drawDateRegex, nextDrawString);
              }
            }
          }
        },
        (err) => {
          return err;
        }
      );
    }
  }

  // this method provides the global template data based on the template id passed to it
  private getGlobalTemplateData(templateType: string): Observable<Data> {
    return this.authService
      .getAngularFireStore("/Global_lookup/template_messages/inbox/" + templateType, "snapshotChanges")
      .pipe(map((res: Data) => res?.payload?.data()));
  }

  formatTime(ms: number): string {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
    const days = Math.floor(ms / (1000 * 60 * 60 * 24));
    if (days > 0) {
      return `${days}d ${hours}hrs ${minutes}m`;
    } else {
      let formattedTime = "";
      if (hours > 0) {
        formattedTime += `${hours}hrs `;
      }
      if (minutes > 0) {
        formattedTime += `${minutes}m `;
      }
      if (seconds > 0) {
        formattedTime += `${seconds}s`;
      }
      return formattedTime.trim();
    }
  }
  ngOnDestroy(): void {
    this.jackpotSubscription?.unsubscribe();
    this.userDetailsSubscription?.unsubscribe();
    this.getCurrencyListSubscription?.unsubscribe();
  }

}
